/**
 * The two standing clarifications on this page.
 *
 * `tone="info"` sits under the KPI row and separates the two sides. `tone="note"`
 * closes the page and states what these figures are NOT, because the single most
 * expensive mistake available here is to read a security as revenue or as a cost.
 *
 * Built with theme tokens rather than fixed light colours: `bg-sky-50` alone
 * would be a white slab in dark mode, so every tone carries its dark pair.
 */
import React from "react";
import { Info } from "lucide-react";

const TONES = {
  info: {
    box: "border-sky-200 bg-sky-50 text-sky-900 dark:border-sky-500/30 dark:bg-sky-500/10 dark:text-sky-200",
    icon: "text-sky-600 dark:text-sky-300",
  },
  note: {
    box: "border-border bg-muted text-muted-foreground",
    icon: "text-muted-foreground",
  },
};

export default function DepositsInfoBanner({ tone = "info", children, testId }) {
  const t = TONES[tone] || TONES.info;

  return (
    <div
      data-testid={testId}
      className={`flex items-start gap-2.5 rounded-xl border p-3.5 text-[12.5px] leading-relaxed ${t.box}`}
    >
      <Info aria-hidden className={`mt-0.5 h-4 w-4 shrink-0 ${t.icon}`} />
      <p className="m-0">{children}</p>
    </div>
  );
}
